import { Moment } from 'moment';

export interface TireNoteId {__noteId: number}

export default class TireNote {
  modifiedOn: Moment | null = null;

  constructor(
    public id: TireNoteId | null = null,
    public content = '',
  ) {}

  static withData(data: Partial<TireNote>): TireNote {
    return Object.assign(new TireNote(), data);
  }
}